//import "./modules/core-js";
(function() {
    let redirect = new URLSearchParams(window.location.search).get('red');
    if (redirect && redirect.length) window.location.assign(redirect);
})();